import { apolloClient } from '@client/api/graphql/client';
import { InfiniteData, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  GetCommunityPostDocument,
  GetCommunityPostQueryVariables,
  GetCommunityPostQuery,
  Post,
} from '../../../../generated/graphql';
import { communityQueryKeys } from '../constants';

export const useCommunityPost = (communityId: number, postId: string) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: communityQueryKeys.post(communityId, postId),
    queryFn: async () => {
      const response = await apolloClient.query<
        GetCommunityPostQuery,
        GetCommunityPostQueryVariables
      >({
        query: GetCommunityPostDocument,
        variables: {
          communityId,
          postId,
        },
        fetchPolicy: 'network-only',
      });

      return response.data.post;
    },
    keepPreviousData: true,
    refetchOnMount: true,
    initialData: () => {
      const previousPosts = queryClient.getQueryData<InfiniteData<Post[]>>(
        communityQueryKeys.posts(communityId),
      );
      if (previousPosts) {
        for (const page of previousPosts.pages) {
          const foundPost = page.find((post) => post.id === postId);
          if (foundPost) return foundPost;
        }
      }
    },
    enabled: typeof communityId !== null && typeof postId !== null,
  });
};
